import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  Validators,
  FormGroup
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import * as moment from "moment";
import { Location } from "@angular/common";
import { Lightbox } from "ngx-lightbox";
import { AlertService } from "src/app/services/alert.service";
import { NavigationService } from "src/app/services/navigation.service";
import { ProductService } from "src/app/services/product.service";
import { GenericValidator } from "src/app/views/layout/validators/generic-validator";
import { environment } from "src/environments/environment";
import { ProductpopupComponent } from "./productpopup/productpopup.component";
import { MatDialog } from "@angular/material/dialog";
import { ProductinfopopupComponent } from "./productinfopopup/productinfopopup.component";
import { ApproveStatusType } from "src/enum/approvestatustype";
import { UserSessionService } from "src/app/services/usersession.service";
import { RoleType } from "src/enum/roletype";
import { ProductUpdatePopupComponent } from "./productupdatepopup/productupdatepopup.component";
import { NestedTreeControl } from "@angular/cdk/tree";
import { MatTreeNestedDataSource } from "@angular/material/tree";
import { BookingFailedTraceModule } from "../../mhire/bookingfailedtrace/bookingfailedtrace.module";
import { ManufacturerService } from "src/app/services/manufacturer.service";
import { ManufacturerLockPopupComponent } from "../homanufacturer/manufacturerLockpopup/manufacturerLockpopup.component";
import { truncate } from "fs";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegionService } from "src/app/services/region.service";
import { SecurityService } from "src/app/services/security.service";
interface FoodNode {
  color?: string;
  name: string;
  children?: FoodNode[];
}
@Component({
  selector: "app-productinfo",
  templateUrl: "./productinfo.component.html",
  styleUrls: ["./productinfo.component.scss"]
})
export class ProductinfoComponent implements OnInit {

  @Input() idD: any
  @Input() Year: any;
  @Output() close = new EventEmitter<boolean>();
  routeParams: any;
  id: number;
  actionInfo: any;
  formEditMode: boolean;
  form: FormGroup;
  testFromList: any[];
  disabled: boolean = false;
  testFromListCopy: any[];
  unitTypeList: any[] = [];
  unitTypeListCopy: any[] = [];
  monthsList: any;
  filtermonthsList: any[];
  yearsList: any;
  filteryearsList: any[];
  productDetail: any;
  today: Date;
  max: Date;
  loading: boolean = false;
  minDate: Date;
  show: boolean = false;
  disabledField: boolean = true;
  schemeName: string;
  productName: any;
  testReportPath: any;
  gstListCopy: any;
  gst: any;
  unitprice: any;
  gstList: any;
  isPriceRelated: boolean = true;
  isTestValidity: boolean = true;
  isTestCenter: boolean = true;
  isTestCertificate: boolean = true;
  public RoleEnumType = RoleType;
  product: any[] = [];
  roleId: any;
  imageviewList: any = [];
  productPhotos: any = [];
  productimages: any = [];
  financeyear: string;
  newunitPrice: number;
  testFileName: any;
  fileType: any;
  testfiles: any;
  filesResult: any;
  attachmentData: any[] = [];
  priceLockStatusType: boolean = false;
  import_filename: any;
  leafletfiles: any;
  importedProductImagePath: string;
  salesInvoiceImagePath: any;
  importyes: boolean = false;
  importno: boolean = false;
  invoice_filename: any;
  isSeekClarification: boolean = false;
  capacityName: any;
  selectedTabIndex: number;
  // private _lightbox: any;
  treeControl = new NestedTreeControl<FoodNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<FoodNode>();
  productTreeList: any[] = [];
  TREE_DATA: FoodNode[] = [];
  priceLockStatus: number;
  IsAllDistrict: boolean = false;
  LeafletPath: any;
  productname: any;
  priceLockStatus1: any;
  isShow: boolean = false;
  session: any;
  session1: any;
  year: any;
  financialYearId: any;
  financialyearlist: any[];
  filterfinancialyearlist: any[];
  currentYear: any;
  form1: FormGroup;
  ProductInfoRes: any;
  curyear: any;
  currentMonth: number;

  constructor(
    private formBuilder: FormBuilder,
    private httpClient: HttpClient,
    private genericValidator: GenericValidator,
    route: ActivatedRoute,
    private productService: ProductService,
    private navigationService: NavigationService,
    private alertService: AlertService,
    private usersession: UserSessionService,
    public addServiceDialog: MatDialog,
    public manufacturerService: ManufacturerService,
    private _location: Location,
    private router: Router,
    private _lightbox: Lightbox,
    private modalService: NgbModal,
    private securityService: SecurityService,
    private regionService: RegionService
  ) {
    this.session = localStorage.getItem("productdetailId");
    this.session1 = JSON.parse(this.session);
    this.routeParams = route.snapshot.params;
    const decId = this.securityService.decrypt(this.routeParams.id);
    this.id = decId;
    this.roleId = this.usersession.roleId();
    this.actionInfo = this.routeParams.actionInfo;
    let year = +this.routeParams.year;
    this.year = year ? year : localStorage.getItem('year');
    if (this.actionInfo == 3) {
      this.show = true;
    }
    if (this.actionInfo == 2) {
      this.formEditMode = false;
    }
    this.loading = false;
  }

  ngOnInit(): void {
    this.initializeValidators();
    this.disabledField = true;
    this.getProductInfo();
    this.getgstList(true);
    var currentYear = new Date().getFullYear();
    var year = currentYear + "-" + (currentYear + 1);
    this.financeyear = year;
    this.getTestedFrom();
    this.getUnitType();
    this.today = new Date();
    this.max = new Date(
      moment(new Date())
        .add(1, "days")
        .format("YYYY, MM, DD")
    );
    // this.getYearJson();
    this.getMonthsJson();
    this.getfinancialyear(true);
    // this.getproductTree();
    this.gstList = [0];

    this.currentMonth = new Date().getMonth();
    this.currentYear = new Date().getFullYear();

  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      id: [this.id, Validators.required],
      classification: [""],
      categoryType: [""],
      make: ["", [Validators.required]],
      // implementType: ['', [Validators.required]],
      model: ["", [Validators.required]],
      capicity: ["", [Validators.required]],
      driveType: [""],
      unitType: [""],
      productReleaseYear: ["", [Validators.required]],
      // productReleaseMonth: ['', [Validators.required]],
      warrantyYear: ["", [Validators.required]],
      warrantyMonth: ["", [Validators.required]],
      webUrl: [""],
      specification: ["", [Validators.required]],
      additionalFeature: [""],
      dbtTestingCentreId: ["", Validators.required],
      testReportNo: ["", Validators.required],
      validityStartTs: ["", Validators.required],
      validityEndTs: [""],
      financialYear: [""],
      effectiveFromTs: ["", Validators.required],
      price: ["", Validators.required],
      unitPrice: ["", Validators.required],
      dbtgstId: ["", Validators.required],
      test_file: [""],
      test_filename: ["", ""],
      import_file: [""],
      import_filename: ["", ""],
      invoice_file: [""],
      invoice_filename: ["", ""],
      TelematicsCost: [0],

    });

    this.form1 = this.formBuilder.group({
      yearId: []
    })
  }



  calculateTotalMRP() {
    const unitPriceStr = this.form.get('unitPrice')?.value;
    const unitPrice = parseFloat(unitPriceStr) || 0;

    let gstPercentage = 0;
    const dbtgstId = this.form.get('dbtgstId')?.value;

    if (this.gstListCopy && dbtgstId) {
      const gstObj = this.gstListCopy.find(i => i.key == dbtgstId);
      if (gstObj) {
        gstPercentage = parseFloat(gstObj.price) || 0;
      }
    }

    const basePrice = unitPrice + (unitPrice * (gstPercentage / 100));

    const telematicsValue = this.form.get('TelematicsCost')?.value;

    const telematicsCost = (telematicsValue === '' || telematicsValue === null || telematicsValue === undefined)
      ? 0
      : parseFloat(telematicsValue) || 0;

    const totalCostMRP = basePrice + telematicsCost;

    if (unitPriceStr !== '' && unitPriceStr !== null && unitPriceStr !== undefined) {
      this.form.get('price')?.setValue(totalCostMRP.toFixed(2), { emitEvent: false });
    } else {
      this.form.get('price')?.setValue(" ", { emitEvent: false });
    }
  }

  getfinancialyear(refresh: boolean) {
    this.regionService.getFinYear(refresh).subscribe(result => {
      if (result) {
        this.financialyearlist = [];
        this.filterfinancialyearlist = [];
        this.financialyearlist = result;
        this.filterfinancialyearlist = this.financialyearlist.slice();

        var financialYear = "";
        if (this.currentMonth >= 0 && this.currentMonth <= 2) {
          financialYear = "FY " + ((this.currentYear - 1).toString() + '-' + this.currentYear.toString().slice(-2));
        } else {
          financialYear = "FY " + ((this.currentYear).toString() + '-' + (this.currentYear + 1).toString().slice(-2));
        }
        this.curyear = this.filterfinancialyearlist.find(i => i.value == financialYear);
        this.form1.controls["yearId"].setValue(this.curyear.key);

        if (this.filterfinancialyearlist.length === 1) {
          this.form1.controls["yearId"].setValue(
            this.filterfinancialyearlist[0].key
          );
        }

        //  var currentYear=new Date().getFullYear();
        //   this.currentYear = this.financialyearlist.filter(x => x.startYear == currentYear);
        //   this.form1.controls["yearId"].setValue(parseInt(this.year));     

        this.yearsList = [];
        this.yearsList = result.map(x => x.startYear);
        this.filteryearsList = this.yearsList;


        if (this.filteryearsList.length === 1) {
          this.form.controls["productReleaseYear"].setValue(
            this.filteryearsList[0]
          );
        } else {
          let currentYear = new Date().getFullYear();
          this.form.controls['productReleaseYear'].setValue(currentYear)
        }

        this.getproductTree();
        // this.form.controls["yearId"].setValue(this.currentYear[0].key);
      }
    });
  }

  change(event: any) {
    this.TREE_DATA = [];
    this.dataSource.data = [];
    this.IsAllDistrict = event.checked;
    this.getproductTree();
  }

  changeYear(e: any) {
    this.getproductTree();
  }

  getproductTree() {
    this.productTreeList = [];
    this.TREE_DATA = []
    this.manufacturerService
      .getProductTreeChartflow(this.id, this.IsAllDistrict, this.form1.value.yearId)
      .subscribe(result => {
        if (result) {
          this.TREE_DATA.push(result);
          this.dataSource.data = this.TREE_DATA;
        }
      });
  }
  expand() {
    this.dataSource.data.forEach(node => {
      if (node.children && node.children) {
        this.treeControl.expand(node);
        node.children.forEach(node1 => {
          this.treeControl.expand(node1);
          node1.children.forEach(node2 => {
            this.treeControl.expand(node2);
          });
        });
      }
    });
  }
  collapse() {
    this.treeControl.collapseAll();
  }
  hasChild = (_: number, node: FoodNode) =>
    !!node.children && node.children.length > 0;

  ontestFileSelected(event1: any) {
    const file = event1.target.files[0];
    if (file.type === "application/pdf") {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 5140).toFixed(2));
      if (acceptsize <= 5140) {
        this.testFileName = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/");
        // this.fileType = getFileType[1]
        if (getFileType[1] == "pdf") {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.testfiles = event.target.result;
            this.filesResult = event.target.result.split(",")[1];
            this.form.controls["test_file"].setValue(this.filesResult);
            this.form.controls["test_filename"].setValue(file.name);
            this.attachmentData.push({
              id: this.attachmentData.length + 1 - 1,
              base64String: this.filesResult,
              attachmentFilename: file.name,
              fileType: this.fileType,
              attachmentType: 22
            });
          };
        }
      } else {
        this.alertService.warning(
          "File size is large, Please upload less than 2 MB"
        );
      }
    } else {
      this.alertService.warning("Please upload JPG, JPEG, PNG and PDF only");
    }
  }

  getProductInfo() {
    this.loading = true;
    this.productService.getProductInfo1(this.id, this.year, true).subscribe(res => {

      this.priceLockStatus1 = res.priceLockStatusType;
      if (this.priceLockStatus1 == 2 || res.isSeekClarification == true ) {
        this.isShow = true
      } else {
        this.isShow = false
      }
      if (res) {
        this.priceLockStatus = res.priceLockStatusType;
        this.ProductInfoRes = res
        if (res.productEditType != "") {
          this.product = JSON.parse(res.productEditType);
          const product = this.product;
          this.isSeekClarification = res.isSeekClarification;


          if (
            product &&
            product.length > 0 &&
            res.approvedStatusType == ApproveStatusType.YettobeVerified &&
            this.roleId != RoleType.DBTAdmin &&
            this.actionInfo != 2
          ) {
            product.forEach(element => {
              if ((element == 1 && res.priceLockStatusType == 1 )) {
                this.isPriceRelated = true;
              } else if (element == 1) {
                this.isPriceRelated = false;
              }
              if (element == 2) {
                this.isTestValidity = false;
              }
              if (element == 3) {
                this.isTestCenter = false;
              }
              if (element == 4) {
                this.isTestCertificate = false;
              }
            });
          }
        }
        this.priceLockStatusType = res.priceLockStatusType == 1 ? true : false;
        if (this.roleId == RoleType.DBTAdmin) {
          this.priceLockStatusType = true;
        }
        this.form.patchValue(res);
        this.capacityName = res.capacityName ? res.capacityName : "Capacity";
        this.financialYearId = res.financialYearId;
        // this.form.controls['driveType'].setValue(result.driveName)
        if ((this.isPriceRelated == true)) {
          this.form.controls["unitType"].setValue(res.unitName);
          this.form.controls["unitPrice"].setValue(
            // "Rs. " +
            res.unitPrice
            // .toLocaleString("en-IN", {
            //   minimumFractionDigits: 2,
            //   maximumFractionDigits: 2
            // })
          );
          this.form.controls["price"].setValue(       // "Rs. " +
            res?.price
            // .toLocaleString("en-IN", {
            //   minimumFractionDigits: 2,
            //   maximumFractionDigits: 2
            // })
          );
          this.form.controls["TelematicsCost"].setValue(res?.telematicsKitCost);
        }

        this.form.controls["classification"].setValue(
          res.machinaryClassificationName
        );
        this.form.controls["categoryType"].setValue(res.machinaryCategoryName);
        this.form.controls["dbtgstId"].setValue(res.dbtgstId);
        //   this.form.controls['validityStartTs'].disable();
        //  this.form.controls['validityEndTs'].disable();
        //  this.form.controls['effectiveFromTs'].disable();
        this.productName = res.productName;
        this.testReportPath = res.testReportPath;
        this.LeafletPath = res.leafletPath;
        this.salesInvoiceImagePath = res.salseInvoiceImagePath;
        this.importedProductImagePath = res.importedProductImagePath;
        this.import_filename = res.importedProductImagePath;
        this.invoice_filename = res.salseInvoiceImagePath;
        this.testFileName = res.testReportPath;

        if (res.isImportedProduct) {
          this.importyes = true;
          this.importno = false;
        } else {
          this.importyes = false;
          this.importno = true;
        }
        this.schemeName = "SMAM";
        this.form.controls["productReleaseYear"].setValue(
          JSON.parse(res.productReleaseYear)
        );
        this.imageviewList = res.image;
        this.imageviewList.forEach(element => {
          element.imagePath =
            environment.imageBaseUrl + "DBT/ProductImage/" + element.imagePath;
        });

      }
      this.loading = false;
    });
    if (this.formEditMode == false) {
      this.form.disable();
    }
  }

  onInvoiceFileSelected(event1: any) {
    const file = event1.target.files[0];
    if (file.type === "application/pdf") {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 2048) {
        this.invoice_filename = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/");
        // this.fileType = getFileType[1]
        if (getFileType[1] == "pdf") {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.leafletfiles = event.target.result;
            this.filesResult = event.target.result.split(",")[1];
            this.form.controls["invoice_file"].setValue(this.filesResult);
            this.form.controls["invoice_filename"].setValue(file.name);
            this.attachmentData.push({
              id: this.attachmentData.length + 1 - 1,
              base64String: this.filesResult,
              attachmentFilename: file.name,
              fileType: this.fileType,
              attachmentType: 25
            });
          };
        }
      } else {
        this.alertService.warning(
          "File size is large, Please upload less than 2 MB"
        );
      }
    } else {
      this.alertService.warning("Please upload PDF only");
    }
  }

  onimportFileSelected(event1: any) {
    const file = event1.target.files[0];
    if (file.type === "application/pdf") {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 2048) {
        this.import_filename = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/");
        // this.fileType = getFileType[1]
        if (getFileType[1] == "pdf") {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.leafletfiles = event.target.result;
            this.filesResult = event.target.result.split(",")[1];
            this.form.controls["import_file"].setValue(this.filesResult);
            this.form.controls["import_filename"].setValue(file.name);
            this.attachmentData.push({
              id: this.attachmentData.length + 1 - 1,
              base64String: this.filesResult,
              attachmentFilename: file.name,
              fileType: this.fileType,
              attachmentType: 26
            });
          };
        }
      } else {
        this.alertService.warning(
          "File size is large, Please upload less than 2 MB"
        );
      }
    } else {
      this.alertService.warning("Please upload PDF only");
    }
  }

  openLockPopup(priceLockStatusType: any) {
    const dialogRef = this.addServiceDialog.open(
      ManufacturerLockPopupComponent,
      {
        autoFocus: false,
        disableClose: true,
        width: "45%",
        height: "50%",
        panelClass: "mat-dialog-serviceschedule",
        data: {
          id: this.id,
          priceLockStatusType: priceLockStatusType,
          financialYearId: this.financialYearId
        }
      }
    );
    dialogRef.afterClosed().subscribe(result => {
      // if (result == true) {
      // this.getProductInfo();
      this.onCancel();
      // }
    });
  }

  getTestedFrom() {
    this.testFromList = [];
    this.testFromListCopy = [];
    this.productService.getTestedFrom(true).subscribe(result => {
      if (result) {
        this.testFromList = result;
        this.testFromListCopy = result;
      }
    });
  }

  goToAction(item: number) {
    var data = {
      id: this.id,
      approvedStatusType: item,
      financialYearId: this.financialYearId


    };
    this.productService.productApprove(data).subscribe(result => {
      // if (result) {
      //   this.alertService.success("Product Approved Successfully");
      //   this._location.back();
      // }

      if (result && result.isSuccess) {
        this.alertService.success("Product Approved Successfully");
        this._location.back();
      } else {
        this.alertService.error(result.htmlFormattedFailures);
        this._location.back();
      }
    });
  }

  getgstList(refresh: boolean) {
    this.productService.getgstList(refresh).subscribe(result => {
      if (result) {
        this.gstList = result;
        this.gstListCopy = this.gstList;
        this.gstListCopy = this.gstListCopy.slice();
      }
    });
  }

  gotoUrl() {
    let src = this.form.value.webUrl;
    window.open(encodeURI(src), "_blank");
  }

  onChange() {
    this.calculateTotalMRP();
  }

  unitPriceevent(event) {
    this.calculateTotalMRP();
  }

  download() {
    let src =
      environment.imageBaseUrl +
      "DBT/Leaflet/" +
      this.LeafletPath;
    window.open(encodeURI(src), "_blank");
  }

  downloadtest() {
    let src =
      environment.imageBaseUrl +
      "DBT/TestReportCertificate/" +
      this.testReportPath;
    window.open(encodeURI(src), "_blank");
  }

  downloadimport() {
    let src =
      environment.imageBaseUrl +
      "DBT/CountryOfOrigin/" +
      this.importedProductImagePath;
    window.open(encodeURI(src), "_blank");
  }

  downloadsalse() {
    let src =
      environment.imageBaseUrl +
      "DBT/SalesInvoice/" +
      this.salesInvoiceImagePath;
    window.open(encodeURI(src), "_blank");
  }

  getUnitType() {
    this.unitTypeList = [];
    this.unitTypeListCopy = [
      {
        key: 1,
        value: "BHP"
      },
      {
        key: 2,
        value: "LTR/HR"
      },
      {
        key: 3,
        value: "HA/HR"
      },
      {
        key: 4,
        value: "KG/HR"
      },
      {
        key: 5,
        value: "UNIT"
      },
      {
        key: 6,
        value: "PTO HP"
      }
    ];
  }

  getMonthsJson() {
    this.httpClient.get("assets/monthsreport.json").subscribe(data => {
      if (data) {
        this.monthsList = [];
        this.filtermonthsList = [];
        this.monthsList = data;
        this.filtermonthsList = this.monthsList.slice();
      }
    });
  }

  getYearJson() {
    this.httpClient.get("assets/dbtyearreport.json").subscribe(data => {
      if (data) {
        this.yearsList = [];
        this.filteryearsList = [];
        this.yearsList = data;
        this.filteryearsList = this.yearsList.slice();
      }
    });
  }

  ischangeEvent() {
    var date = moment(this.form.value.startdate).format("YYYY-MM-DD");
    this.minDate = new Date(date);
  }
  oncancel1() {
    this.navigationService.goToDealerInfo();
  }
  onCancel() {
    const manufacturerId = this.session1;
    localStorage.removeItem("productdetailId");
    if (manufacturerId != null) {
      const encId = this.securityService.encrypt(manufacturerId);
      this.navigationService.goTOManufacturerDetail(encId, 2);
    } else {
      this._location.back();
    }
  }

  showUpdatePopup() {
    const dialogRef = this.addServiceDialog.open(ProductUpdatePopupComponent, {
      autoFocus: false,
      disableClose: true,
      width: "45%",
      height: "55%",
      panelClass: "mat-dialog-serviceschedule",
      data: {
        id: this.id,
        testReportNo: this.form.value.testReportNo,
        validityStartTs: moment(this.form.value.validityStartTs).format(
          "YYYY-MM-DD"
        ),
        validityEndTs: moment(this.form.value.validityEndTs).format(
          "YYYY-MM-DD"
        ),
        dbtTestingCentreId: this.form.value.dbtTestingCentreId,
        price: this.form.value.price,
        unitPrice: this.form.value.unitPrice,
        dbtgstId: this.form.value.dbtgstId,
        telematicsKitCost: Number(this.form.value.TelematicsCost) || 0,
        attachment: this.attachmentData,
        effectiveFromTs: moment(this.form.value.effectiveFromTs).format("YYYY-MM-DD"),
        financialYearId: this.financialYearId
      }
    });
    dialogRef.afterClosed().subscribe(data => {
      //  this._location.back();
    });
  }

  onSubmit() {
    this.form.controls["validityEndTs"].clearValidators();
    this.form.controls["validityEndTs"].updateValueAndValidity();
    if (this.form.value.specification.length < 300) {
      if (this.form.valid) {
        if (this.isSeekClarification) {
          this.showUpdatePopup();
        } else {
          let data = {
            id: this.id,
            testReportNo: this.form.value.testReportNo,
            validityStartTs: moment(this.form.value.validityStartTs).format(
              "YYYY-MM-DD"
            ),
            validityEndTs: moment(this.form.value.validityEndTs).format(
              "YYYY-MM-DD"
            ),
            dbtTestingCentreId: this.form.value.dbtTestingCentreId,
            price: this.form.value.price,
            unitPrice: this.form.value.unitPrice,
            dbtgstId: this.form.value.dbtgstId,
            telematicsKitCost: Number(this.form.value.TelematicsCost) || 0,
            attachment: this.attachmentData,
            approvedStatusType: this.priceLockStatus == 2 ? 9 : 0,
            effectiveFromTs: moment(this.form.value.effectiveFromTs).format(
              "YYYY-MM-DD"
            ),
            financialYearId: this.financialYearId
          };
          this.productService.productUpdate(data).subscribe(res => {
            if (res && res.isSuccess) {
              this.alertService.success("Product Updated Successfully");
              this._location.back();
            }
          });
        }
      } else {
        this.validateFormControl();
      }
    } else {
      this.alertService.warning("Specification / விவரக்குறிப்பு character length should be less than 300");
    }
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    });
  }

  openPopup() {
    const dialogRef = this.addServiceDialog.open(ProductpopupComponent, {
      autoFocus: false,
      disableClose: true,
      width: "38%",
      height: "45%",
      panelClass: "mat-dialog-serviceschedule",
      data: {
        id: this.id,
        financialYearId: this.financialYearId
      }
    });
  }

  showPopup(type: any) {
    const dialogRef = this.addServiceDialog.open(ProductinfopopupComponent, {
      autoFocus: false,
      disableClose: true,
      width: "45%",
      height: "55%",
      panelClass: "mat-dialog-serviceschedule",
      data: {
        id: this.id,
        financialYearId: this.financialYearId,
        type: type
      }
    });
  }

  openImage(showImage, item): void {
    this.modalService.open(showImage, { centered: true })
    this.productPhotos = [];
    this.productimages = [];
    this.productPhotos = item.imagePath;
    this.productname = item.productName
    this.imageviewList.forEach(e => {
      this.productimages.push({
        src: e.imagePath,
        thumb: e.imagePath
      });
    });
    // this._lightbox.open(this.productimages, 0, { centerVertically: true });
  }

  getColor(node: FoodNode) {
    if (this.dataSource.data[0]?.children?.[0]?.children?.length === 0) {
      return "white";
    } else if (
      !this.dataSource.data[0]?.children?.[0]?.children?.[0].children
    ) {
      if (!node?.children) {
        return node.color;
      } else {
        return "white";
      }
    } else if (!node?.children?.[0]?.children || !node?.children) {
      return node.color;
    } else {
      return "white";
    }
  }

  getBgColor(node: FoodNode) {
    if (this.dataSource.data[0]?.children?.[0]?.children?.length === 0) {
      return node.color;
    } else if (
      !this.dataSource.data[0]?.children?.[0]?.children?.[0].children
    ) {
      if (!node?.children) {
        return "white";
      } else {
        return node.color;
      }
    } else if (!node?.children?.[0]?.children || !node?.children) {
      return "white";
    } else {
      return node.color;
    }
  }

  view(id: number) {
    const encId = this.securityService.encrypt(id);
    this.navigationService.goTODealerview(encId, 2, 2);
  }
}
